module.exports = __webpack_public_path__ + "5e48c74a108e984501ce25567c6a0796.jpg";